var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.7487 5.63659C13.0487 2.55659 10.362 1.16992 8.00202 1.16992C8.00202 1.16992 8.00202 1.16992 7.99535 1.16992C5.64202 1.16992 2.94868 2.54992 2.24868 5.62992C1.46868 9.06992 3.57535 11.9833 5.48202 13.8166C6.18868 14.4966 7.09535 14.8366 8.00202 14.8366C8.90868 14.8366 9.81535 14.4966 10.5154 13.8166C12.422 11.9833 14.5287 9.07659 13.7487 5.63659Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8.00234 8.97734C9.16214 8.97734 10.1023 8.03714 10.1023 6.87734C10.1023 5.71755 9.16214 4.77734 8.00234 4.77734C6.84255 4.77734 5.90234 5.71755 5.90234 6.87734C5.90234 8.03714 6.84255 8.97734 8.00234 8.97734Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e288da27.svg";
export { ForwardRef as ReactComponent };